import { Purchase } from '@nakedplatform/support';
const CENTS = 100;

export enum EventType {
  ViewQuote = 'Frontend Quote Completed',
  PurchaseCover = 'Frontend Purchase Completed',
  SignUp = 'Frontend Sign Up ',
}
/**
 * Prepares the facebook event for segment
 *
 * @param prospect - The prospect purchase information
 */
export function getPurchaseEvent(prospect: Purchase) {
  const { itemType, prospectHash, prospectId, premiumPerPeriod, ...rest } = prospect;
  const premium = Math.ceil(premiumPerPeriod / CENTS);
  const id = prospectHash || prospectId;

  return {
    content_name: 'Quote Summary',
    content_category: itemType,
    content_type: 'product',
    value: premium,
    contents: [
      {
        id,
        quantity: 1,
        item_price: premium,
      },
    ],
    ...rest,
  };
}
/**
 * Prepares the facebook event for segment
 *
 * @param prospect - The prospect purchase information
 */
export function getViewQuoteEvent(prospect: Purchase) {
  return getPurchaseEvent({
    ...prospect,
    value: 0,
  });
}
/**
 * Prepares facebook registration event for segment
 */
export function getRegistrationEvent() {
  return {
    content_name: 'Sign Up',
    status: 'SUBMIT_SIGNUP',
    value: 0,
  };
}
